export interface AuthUser {
  id: string;
  username: string;
  email: string;
  name: string;
  role?: 'user' | 'admin';
  createdAt: number;
  updatedAt: number;
}

interface AuthClientApi {
  bootstrapAuth: () => Promise<{ authenticated: boolean; user: AuthUser | null }>;
  login: (identifier: string, password: string) => Promise<unknown>;
  register: (username: string, email: string, password: string, name?: string) => Promise<unknown>;
  logout: () => Promise<unknown>;
  me: () => Promise<AuthUser>;
  updateProfile: (name: string) => Promise<AuthUser>;
  changePassword: (currentPassword: string, newPassword: string) => Promise<unknown>;
  forgotPassword: (identifier: string) => Promise<{ ok: true; message: string; recoveryToken?: string }>;
  resetPassword: (token: string, password: string) => Promise<unknown>;
  getAccessToken: () => string;
  getUser: () => AuthUser | null;
  getAuthState: () => { authenticated: boolean; user: AuthUser | null; online: boolean };
}

function client(): AuthClientApi {
  if (!window.__mindplaceAuth) throw new Error('El cliente de autenticación todavía no está disponible.');
  return window.__mindplaceAuth as AuthClientApi;
}

export const authService = {
  bootstrap: () => client().bootstrapAuth(),
  login: (identifier: string, password: string) => client().login(identifier, password),
  register: (username: string, email: string, password: string, name = '') => client().register(username, email, password, name),
  logout: () => client().logout(),
  me: () => client().me(),
  updateProfile: (name: string) => client().updateProfile(name),
  changePassword: (currentPassword: string, newPassword: string) => client().changePassword(currentPassword, newPassword),
  forgotPassword: (identifier: string) => client().forgotPassword(identifier),
  resetPassword: (token: string, password: string) => client().resetPassword(token, password),
  state: () => client().getAuthState(),
};
